/* istanbul ignore file */
// TODO: Maybe DeviceType should be renamed Breakpoint or ViewPort or something
// note: keep this outside of the useBreakpoint hook so that we don't accidently mock it.
// note: the largest device type should be the greatest weight so we can do `if deviceType < DeviceType.Desktop` for if the device is smaller than desktop.
export enum DeviceType {
  Mobile = 0,
  Tablet = 1,
  Desktop = 2
}
